module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-search/eventsearch-postedremittance-gladjustment/eventsearch-postedremittance-gladjustment.component.css
// module id = ./src/app/components/event-search/eventsearch-postedremittance-gladjustment/eventsearch-postedremittance-gladjustment.component.css
// module chunks = main